import styled, { css } from "styled-components";
import { IContainerProps, ISolfaNameButtonProps, SolfaButtonInProps } from "./interfaces";

export const StyledSolfaLadder = styled.div`
    bottom: 65px;
    height: 90px;
    width: 100%;
    left: 0px;
`;

export const Container = styled.div<IContainerProps>`
    width: ${p => (p.isEditor ? 2090 : 1280)}px;
    height: 90px;
    padding-top: 10px;
    display: block;
    margin: auto;
    position: relative;
    text-align: center;
    ${p =>
        p.isLow
            ? css`
                  width: ${1280 / 0.75}px;
                  margin-left: ${(1280 - 1280 / 0.75) / 2}px;
              `
            : undefined}
`;

export const SolfaButtons = styled.div`
    height: 90px;
    user-select: none;
    display: inline-block;
    position: relative;
`;

export const SolfaNameButton = styled.div<ISolfaNameButtonProps>`
    width: 72px;
    height: 72px;
    border-radius: 36px;
    display: inline-block;
    text-align: center;
    line-height: 72px;
    margin-right: 4px;
    cursor: pointer;
    position: relative;

    &:last-of-type {
        margin-right: 0;
    }

    ${p =>
        p.marginRight &&
        css`
            margin-right: 32px;
        `}
    -webkit-tap-highlight-color: transparent;

    transition: 0.2s;
    font-size: 30px;
    box-shadow: none;
    color: ${p => p.theme.c.whiteOnActive};
    text-shadow: 0 0 3px ${p => p.theme.c.blackShadow3};

    &.smallSeed {
        ${"" /* box-shadow: 0 0 0 0.9px ${frameColor} inset; */}
        background-color: transparent;
        cursor: default;
        text-shadow: none;
        color: transparent;
    }
    &.highlight {
        transform: scale(1.06, 1.06);
        div div {
            ${p =>
                !p.coloring &&
                css`
                    background-color: ${p.theme.c.active};
                `}
            color: white;
        }
        box-shadow: none;
    }
`;

export const SolfaButtonIn = styled.div<SolfaButtonInProps>`
    background-color: ${p => (p.coloring ? p.theme.c.solfa[p.solfaShort] : p.theme.c.whiteOnActive)};
    color: ${p => (p.coloring ? p.theme.c.whiteOnActive : (p.theme.mode === "dark" ? p.theme.c.white : p.theme.c.black))};
    border: 3px solid black;
    box-sizing: border-box;
    width: 72px;
    height: 72px;
    border-radius: 36px;
    transition: 300ms;
    transform: scale(1, 1);
    ${p =>
        p.modified &&
        !p.coloring &&
        css`
            background-color: ${p => p.theme.c.active};
        `}
    &.Selected {
        background-color: ${p => p.theme.c.info};
        color: ${p => p.theme.c.whiteOnActive};
    }

    .italic {
        font-style: italic;
    }
`;

export const SmallCircle = styled.div`
    width: 22px;
    height: 22px;
    border-radius: 11px;
    position: absolute;
    top: 25px;
    left: 25px;
    background-color: black;
`;

export const Line = styled.div`
    position: absolute;
    left: 4px;
    width: calc(100% - 40px);
    background-color: black;
    height: 3px;
    top: 34px;
`;

export const AssetWrapper = styled.div`
    position: absolute;
    top: 69px;
    left: -13px;
    pointer-events: none;
    background-color: transparent !important;
    img {
        width: 156px;
    }
`;
